import { useHasFocus } from '@axo/shared/ui/input/hooks/useHasFocus';
import DropdownUI from '@axo/shared/ui/input/lib/Dropdown/DropdownUI';
import { IOption } from '@axo/shared/ui/input/lib/RadioGroup/RadioGroupUI';
import { FieldError, useFormContext } from 'react-hook-form';
import { usePrimaryState, useReloadValue, useValidationUI } from '../../hooks';
import { IField } from '../UI.types';

interface IDropdownField<Fields> extends IField<Fields> {
  label?: string;
  options: IOption[];
  placeholder?: string;
  defaultValue?: string;
  shouldTouch?: boolean;
  error?: FieldError;
  valid?: boolean;
}

export function DropdownFieldUI<Fields>({
  label,
  name,
  tooltipValidation,
  warningValidation,
  successValidation,
  options,
  registerOptions,
  placeholder = '',
  defaultValue = '',
  shouldTouch = false,
  error,
  valid,
  ...props
}: IDropdownField<Fields>) {
  const { register } = useFormContext();

  const registerProps = register(name, registerOptions);
  const { hasFocus, ...useHasFocusEventHandlers } = useHasFocus(registerProps);
  useReloadValue(name, { shouldTouch });

  const { infoBox, isValidating } = useValidationUI({
    name,
    hasFocus,
    warningValidation,
    successValidation,
    tooltipValidation,
    formControllerError: error,
  });

  const primaryState = usePrimaryState({
    infoBoxType: infoBox?.type,
    isValidating,
    name,
    hasFocus,
    valid,
  });

  return (
    <DropdownUI
      {...registerProps}
      {...useHasFocusEventHandlers}
      placeholder={placeholder}
      options={options}
      label={label}
      state={primaryState}
      infoBox={infoBox}
      defaultValue={defaultValue}
      {...props}
    />
  );
}
